import * as React from 'react';
import { useSelector } from 'react-redux';
import { getBuildersList } from '../../selectors/builders';
import { BuilderCardContainer } from '../BuilderCardContainer';
import { getPagination } from '../../selectors/pagination';
import { BannerContainer } from '../BannerContainer/BannerContainer';

const BANNER_POSITION = 5;

export const BuildersListingContainer = () => {
  const builders = useSelector(getBuildersList);
  const { page } = useSelector(getPagination);

  if (!builders) {
    return null;
  }

  const injectAfterCards = builders.length <= BANNER_POSITION;
  const isFirstPage = page === 1;

  return (
    <>
      <div data-name="BuildersListing">
        {builders &&
          builders.map(
            (
              {
                id,
                foundationYear,
                name,
                logo,
                images,
                materials,
                otherMaterials,
                projectStartPrice,
                projectsType,
                phone,
              },
              index,
            ) => {
              const isBannerPosition = index === BANNER_POSITION - 1;

              return (
                <React.Fragment key={id}>
                  {!injectAfterCards && isBannerPosition && isFirstPage && <BannerContainer />}
                  <BuilderCardContainer
                    age={foundationYear}
                    name={name}
                    logo={logo}
                    images={images}
                    materials={materials}
                    otherMaterials={otherMaterials}
                    projectStartPrice={projectStartPrice}
                    projectsTypes={projectsType}
                    phone={phone}
                    companyId={id}
                    index={index}
                  />
                </React.Fragment>
              );
            },
          )}
      </div>
      {injectAfterCards && isFirstPage && <BannerContainer />}
    </>
  );
};
